import swiperUtil from '../utils/swiper-util';

export default (node) => {
  const swiperNode = node.querySelector('[data-swiper]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');
  const numberOfSlides = node.getAttribute('data-number-of-slides');
  const stackOnMobile = node.getAttribute('data-stack-on-mobile') === 'true';
  const setMaxSlides = node.getAttribute('data-set-max-slides') || 0;
  let swiperElement = null;

  if (stackOnMobile) {
    const mq = window.matchMedia(`(min-width: 768px)`);

    mq.addEventListener('change', handleMediaQueryChange);

    function handleMediaQueryChange(event) {
      if (event.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }
  }

  function destroySwiper() {
    if (swiperElement) {
      swiperElement.destroy();
    }
  }


  const initSwiper = () => {
    let slidesPerView = 1;
    let breakpoints = {
      768: {
        slidesPerView: Number(setMaxSlides),
      },
      1024: {
        slidesPerView: Number(setMaxSlides),
      },

    }

    if (Number(setMaxSlides) == 0) {
      slidesPerView = 1.5;
      breakpoints = {
        768: {
          slidesPerView: 2.8,
        },
        1024: {
          slidesPerView: 4.2,
        },
      };
      if (Number(numberOfSlides) < 4) {
        breakpoints = {
          768: {
            slidesPerView: Number(numberOfSlides),
          },
        };
      }
    }

    swiperElement = swiperUtil(swiperNode, {
      spaceBetween: 0,
      slidesPerView: slidesPerView,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: breakpoints,
    });
  };

  if (swiperNode) initSwiper();
};
